import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SuccessPopupComponent } from '../../../../../core/libraries/popup/components/success-popup/success-popup.component';
import { AuthService } from '../../../../../core/services/api/auth/auth.service';
import { LoaderService } from '../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-verify-email',
    standalone: false,
    templateUrl: './verify-email.component.html',
    styleUrl: './verify-email.component.scss',
})
export class VerifyEmailComponent {
    protected email = this.route.snapshot.queryParamMap.get('email') || '';

    constructor(
        private route: ActivatedRoute,
        private authService: AuthService,
        private loaderService: LoaderService,
        private dialog: MatDialog,
    ) {}

    protected resendVerifyEmail(): void {
        this.loaderService.show();
        this.authService.resendVerifyEmail(this.email).subscribe({
            next: () => {
                const popupConfig = SuccessPopupComponent.getDialogConfig();
                popupConfig.data = {
                    title: 'Check your inbox!',
                    message: `We’ve sent a fresh verification link to <strong>${this.email}</strong>`,
                };
                this.dialog.open(SuccessPopupComponent, popupConfig);
            },
            error: (error) => {
                const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                errorPopupConfig.data = {
                    title: `Error`,
                    message: error.error?.message,
                };
                this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                console.error('Error on resending verfication email', error);
            },
            complete: () => {
                this.loaderService.hide();
            },
        });
    }
}
